import { Icons } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { AButton } from 'views/components/Analytics'

export const DownloadAsExcel: FC<{ sampleId: number }> = ({ sampleId }) => {
  const { t } = useTranslation('samples')

  const [progress, download] = useAProgress(
    () =>
      apiClient.get(endpoints.samplePartsAsExcel(sampleId.toString()), undefined, {
        responseType: 'blob',
      }),
    {
      eventName: 'downloadSamplePartsTable',
    },
  )

  return (
    <AButton id="downloadTable" color="secondary" progress={progress} Icon={Icons.IconDescription} onClick={download}>
      {t('downloadTable')}
    </AButton>
  )
}
